import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");

    if (!sessionId) {
      navigate("/login");
      return;
    }

    const exchange = async () => {
      try {
        await googleAuth(sessionId);
        // Clear hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (err) {
        console.error("Auth callback error:", err);
        navigate("/login");
      }
    };
    exchange();
  }, [googleAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-nordic-bg" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-nordic-blue border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-nordic-text-secondary text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
